//deprecated but leave it for backward compatibility
module.exports.core=require("./core");

//live apis
module.exports=require("./core");
module.exports.interfaces = require("./interfaces");
